<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Standard Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="form-horizontal">
    @if (crudLoading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    
    @if (!crudLoading) {
<div>
      <div class="panel panel-default">
        <div class="panel-body">
          <div>
            <div class="mb-30">
              <div class="form-group col-xs-3 col-md-2">
                <label for="taxYear" class="control-label">Tax Year</label>  
                <div class="tax-year-display">
                  <strong>{{taxYear}}</strong>
                </div>			
              </div>

              <div class="form-group col-xs-3 col-md-3">
                <label for="apportionment" class="control-label">Apportionment</label> 
                <select id="FTC_SS861_CD_4" 
                        class="form-control" 
                        [(ngModel)]="configGIEAppr"
                        (ngModelChange)="onApprChange()"
                        [compareWith]="compareConfigOptions">
                  <option [ngValue]="null" disabled>Select Apportionment</option>
                  @for (option of configGIEApprtionData; track trackByCodeKey($index, option)) {
<option 
                          [ngValue]="option">
                    {{option.CODE_DESCRIPTION}}
                  </option>
}
                </select>
              </div>

              <div class="form-group col-xs-1 col-md-1">&nbsp;</div>
              
              <div class="form-group col-xs-3 col-md-3">
                <label for="configuration" class="control-label">Configuration</label> 
                <select id="FTC_SS861_CD_3" 
                        class="form-control" 
                        [(ngModel)]="configuration"
                        [compareWith]="compareConfigOptions">
                  <option [ngValue]="null" disabled>Select Configuration</option>
                  @for (option of configInfo; track trackByCodeKey($index, option)) {
<option 
                          [ngValue]="option">
                    {{option.CODE_DESCRIPTION}}
                  </option>
}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
}
  </div>
</div>

<!-- Standard Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"  
          type="button"  
          [disabled]="isSaveClicked"  
          (click)="save()"> 
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"  
          type="button"  
          (click)="reset()">Reset</button>
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>
